"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCssProperty = exports.convertToCssString = void 0;
var lodash_1 = require("lodash");
var defaultTheme_1 = __importDefault(require("../theme/defaultTheme"));
var convertToCssString = function (inlineStyles) {
    var getMediaCss = function (v) {
        var cssInMedia = Object.entries(v === null || v === void 0 ? void 0 : v.css)
            .map(function (_a) {
            var k = _a[0], v = _a[1];
            return lodash_1.kebabCase(k) + ":" + v;
        })
            .join(';');
        var widthType = (v === null || v === void 0 ? void 0 : v.min) ? 'min' : 'max';
        var breakpoint = v === null || v === void 0 ? void 0 : v.breakpoint;
        if (breakpoint === 'mobile')
            breakpoint = defaultTheme_1.default.breakpointMobile;
        else if (breakpoint === 'tablet')
            breakpoint = defaultTheme_1.default.breakpointTablet;
        else if (breakpoint === 'desktop')
            breakpoint = defaultTheme_1.default.breakpointDesktop;
        else if (breakpoint === 'widescreen')
            breakpoint = defaultTheme_1.default.breakpointWidescreen;
        else if (breakpoint === 'fullHd')
            breakpoint = defaultTheme_1.default.breakpointFullHd;
        else if (typeof breakpoint === 'number')
            breakpoint = breakpoint + "px";
        return "@media (" + widthType + "-width: " + breakpoint + ") {" + cssInMedia + "}";
    };
    var cssRules = Object.entries(inlineStyles)
        .map(function (_a) {
        var k = _a[0], v = _a[1];
        if (k === 'media') {
            return v
                .map(function (mediaObj) {
                return getMediaCss(mediaObj);
            })
                .join(' ');
        }
        return lodash_1.kebabCase(k) + ":" + v;
    })
        .join(';');
    return cssRules;
};
exports.convertToCssString = convertToCssString;
var toCssProperty = function (property, deviceSize) {
    // @ts-ignore
    if (!property || !deviceSize || !property[deviceSize]) {
        deviceSize = 'desktop';
    }
    /// ### TODO set default to desktop
    if (deviceSize && typeof property === 'object') {
        if (typeof property[deviceSize] === 'string')
            return property[deviceSize];
        else if (property[deviceSize])
            return property[deviceSize] + "px";
    }
    else if (typeof property === 'string')
        return property;
    else if (property)
        return property + "px";
    return '';
};
exports.toCssProperty = toCssProperty;
//# sourceMappingURL=helperFunctions.js.map